import { pageActions }          from './page.js'
import { sectionActions }       from './section.js'
import { modActions }           from './mod.js'

export function bootstrap() {
    pageActions()
    sectionActions()
    modActions()
}
